import { BenefitCard } from './BenefitCard'
import { useNaturalPowerRatio } from './NaturalPowerCalculatorProvider'

export type BenefitCards = { title?: string; image?: string; description: string }[]

interface BenefitsProps {
  cards: BenefitCards
}

export function Benefits({ cards }: BenefitsProps) {
  const naturalPowerRatio = useNaturalPowerRatio()

  const cardTitle = (title?: string, image?: string) => {
    if (image) {
      return <img src={image} alt={title || ''} className="inline-block max-w-full max-h-9" />
    }
    if (title) {
      return title
    }
    return null
  }
  return (
    <div className="flex flex-col gap-y-4 gap-x-5 md:col-span-2">
      <h4 className="text-xl font-normal text-navy">The benefits</h4>
      <div className="grid content-end justify-end grid-cols-1 md:grid-cols-2 gap-y-4 md:gap-x-12">
        {cards.map(({ title, image, description }, index) => (
          <BenefitCard
            key={`${title}-${index}`}
            title={cardTitle(title, image)}
            description={description}
            active={naturalPowerRatio > 0}
          />
        ))}
      </div>
    </div>
  )
}
